export default {
  props: {
    hideBudgetEntitiesTab: {
      type: Boolean,
      required: false,
      default: false,
    }
  }
}
